const ABProcessGatewayExclusiveCore = require("../../../core/process/tasks/ABProcessGatewayExclusiveCore");
module.exports = class ABProcessGatewayExclusive extends (
   ABProcessGatewayExclusiveCore
) {};
